/**
 * Home Second Page Scripts
 * This file contains custom JavaScript for the template-home-second.php template
 */

jQuery(document).ready(function($) {

    // NEW HERO START
    /**
     * Simple Hero Section with Synchronized Carousels
     */
    function initSimpleHero() {
        var $section = $('.simple-hero-section');
        if (!$section.length) return;

        var $contentCarousel = $section.find('.content-carousel');
        var $imageCarousel = $section.find('.image-carousel');
        var $mobileTitleCarousel = $section.find('.mobile-title-carousel');
        var $navDots = $section.find('.nav-dot');
        var currentSlide = 0;
        var totalSlides = $contentCarousel.find('.content-slide').length;
        var isAnimating = false;
        
        // Get Lenis instance if available
        var lenis = typeof window.lenis !== 'undefined' ? window.lenis : null;
        
        // Store current scroll position to prevent jumps
        var lockedScrollPosition = null;
        
        // Function to lock scroll at current position
        function lockScroll() {
            lockedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            
            // Prevent scroll on Lenis
            if (lenis) {
                lenis.stop();
            }
            
            // Prevent default browser scroll
            window.addEventListener('scroll', preventScroll, { passive: false });
        }
        
        // Function to unlock scroll
        function unlockScroll() {
            window.removeEventListener('scroll', preventScroll);
            
            // Resume Lenis
            if (lenis) {
                lenis.start();
            }
            
            lockedScrollPosition = null;
        }
        
        // Prevent scroll event handler
        function preventScroll() {
            if (lockedScrollPosition !== null) {
                window.scrollTo(0, lockedScrollPosition);
            }
        }

        // GSAP Animation Functions
        // `isInitial` is true only for the very first paint (page load), before we
        // know JS/GSAP definitely ran to completion. On that first call we animate
        // position/scale only and never touch opacity, so the content is guaranteed
        // visible even if this code is slow, errors, or a renderer (e.g. Google's
        // screenshot tool) captures the page mid-animation. Slide-to-slide
        // transitions (isInitial = false) happen only after a user/auto interaction,
        // at which point JS is confirmed running, so the opacity fade is safe there.
        // Wrap a gsap tween in a real Promise (gsap tweens aren't promises, so
        // Promise.all() on a raw tween resolves immediately instead of waiting
        // for it to finish - this onComplete hookup makes the wait real).
        function tweenPromise(tween) {
            return new Promise(function(resolve) {
                if (!tween) { resolve(); return; }
                tween.eventCallback('onComplete', resolve);
            });
        }

        function animateContentIn($slide, isInitial) {
            if (!$slide.length) return;

            var $content = $slide.find('.slide-content');

            // Always state the destination value explicitly (fromTo) instead of
            // letting GSAP infer it from the element's current state (from). The
            // out-animation leaves opacity permanently at 0 as its end value, so a
            // later gsap.from() on the same element would capture that 0 as its
            // target and tween 0 -> 0, leaving the slide invisible forever once it
            // cycles back around.
            if (isInitial) {
                gsap.fromTo($content, { scale: 0.9, y: 30 }, { scale: 1, y: 0, duration: 0.8, ease: "back.out(1.7)" });
            } else {
                gsap.fromTo($content, { opacity: 0, scale: 0.9, y: 30 }, { opacity: 1, scale: 1, y: 0, duration: 0.8, ease: "back.out(1.7)" });
            }

            // Stagger child elements
            if (isInitial) {
                gsap.fromTo($content.find('h2, p'), { y: 20 }, { y: 0, duration: 0.6, stagger: 0.1, delay: 0.2, ease: "power2.out" });
            } else {
                gsap.fromTo($content.find('h2, p'), { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6, stagger: 0.1, delay: 0.2, ease: "power2.out" });
            }

            // Animate CTA buttons in sync
            var $ctaButtons = $('#hero-cta-btn-1, #hero-cta-btn-2');
            if ($ctaButtons.length) {
                if (isInitial) {
                    gsap.fromTo($ctaButtons, { y: 20 }, { y: 0, duration: 0.6, delay: 0.4, stagger: 0.1, ease: "back.out(1.5)" });
                } else {
                    gsap.fromTo($ctaButtons, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6, delay: 0.4, stagger: 0.1, ease: "back.out(1.5)" });
                }
            }
        }

        function animateContentOut($slide) {
            if (!$slide.length) return;

            var $content = $slide.find('.slide-content');

            var promises = [];

            // Animate content out
            promises.push(tweenPromise(gsap.to($content, {
                opacity: 0,
                scale: 0.8,
                y: -20,
                duration: 0.4,
                ease: "power2.in"
            })));

            // Animate CTA buttons out
            var $ctaButtons = $('#hero-cta-btn-1, #hero-cta-btn-2');
            if ($ctaButtons.length) {
                promises.push(tweenPromise(gsap.to($ctaButtons, {
                    opacity: 0,
                    y: -10,
                    duration: 0.3,
                    stagger: 0.05, // Quick stagger for out animation
                    ease: "power2.in"
                })));
            }

            return Promise.all(promises);
        }

        function animateImageIn($slide, isInitial) {
            if (!$slide.length) return;

            var $wrapper = $slide.find('.image-wrapper');
            var $icons = $wrapper.find('.icon');
            var $badge = $wrapper.find('.badge');

            // See animateContentIn: always state the explicit destination value
            // (fromTo) so a slide that previously animated out doesn't get stuck
            // at opacity 0 when it cycles back in.
            if (isInitial) {
                gsap.fromTo($wrapper, { scale: 0.8, rotationY: -15 }, { scale: 1, rotationY: 0, duration: 1, ease: "back.out(1.2)" });
            } else {
                gsap.fromTo($wrapper, { opacity: 0, scale: 0.8, rotationY: -15 }, { opacity: 1, scale: 1, rotationY: 0, duration: 1, ease: "back.out(1.2)" });
            }

            // Animate floating icons
            if (isInitial) {
                gsap.fromTo($icons, { scale: 0, rotation: -180 }, { scale: 1, rotation: 0, duration: 0.8, stagger: 0.1, delay: 0.5, ease: "back.out(2)" });
            } else {
                gsap.fromTo($icons, { opacity: 0, scale: 0, rotation: -180 }, { opacity: 1, scale: 1, rotation: 0, duration: 0.8, stagger: 0.1, delay: 0.5, ease: "back.out(2)" });
            }

            // Animate badge
            if (isInitial) {
                gsap.fromTo($badge, { y: 20, scale: 0.8 }, { y: 0, scale: 1, duration: 0.6, delay: 0.8, ease: "back.out(1.5)" });
            } else {
                gsap.fromTo($badge, { opacity: 0, y: 20, scale: 0.8 }, { opacity: 1, y: 0, scale: 1, duration: 0.6, delay: 0.8, ease: "back.out(1.5)" });
            }
        }

        function animateImageOut($slide) {
            if (!$slide.length) return;

            var $wrapper = $slide.find('.image-wrapper');

            return tweenPromise(gsap.to($wrapper, {
                opacity: 0,
                scale: 0.9,
                rotationY: 15,
                duration: 0.5,
                ease: "power2.in"
            }));
        }

        // Mobile Title Carousel Animation Functions
        function animateMobileTitleIn($slide, isInitial) {
            if (!$slide.length) return;

            var $h2 = $slide.find('h2');

            // See animateContentIn: state the explicit destination value so a
            // title that previously faded out doesn't get stuck invisible.
            if (isInitial) {
                gsap.fromTo($h2, { scale: 0.9, y: 30 }, { scale: 1, y: 0, duration: 0.8, ease: "back.out(1.7)" });
            } else {
                gsap.fromTo($h2, { opacity: 0, scale: 0.9, y: 30 }, { opacity: 1, scale: 1, y: 0, duration: 0.8, ease: "back.out(1.7)" });
            }
        }

        function animateMobileTitleOut($slide) {
            if (!$slide.length) return;

            var $h2 = $slide.find('h2');

            return tweenPromise(gsap.to($h2, {
                opacity: 0,
                scale: 0.8,
                y: -20,
                duration: 0.4,
                ease: "power2.in"
            }));
        }

        // Initialize carousels without animations
        $contentCarousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: false,
            speed: 0,
            cssEase: 'linear',
            swipe: false,
            touchMove: false,
            infinite: false,
            variableWidth: false,
            adaptiveWidth: false
        });

        $imageCarousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: false,
            speed: 0,
            cssEase: 'linear',
            swipe: false,
            touchMove: false,
            infinite: false,
            variableWidth: false,
            adaptiveWidth: false
        });

        // Initialize mobile title carousel
        if ($mobileTitleCarousel.length) {
            $mobileTitleCarousel.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                fade: true,
                speed: 0,
                cssEase: 'ease',
                swipe: false,
                touchMove: false,
                infinite: false,
                variableWidth: false,
                adaptiveWidth: false
            });

            console.log('Mobile title carousel initialized with', $mobileTitleCarousel.find('.mobile-title-slide').length, 'slides');
        }

        // Force recalculate widths after initialization
        setTimeout(function() {
            $contentCarousel.slick('setPosition');
            $imageCarousel.slick('setPosition');
            if ($mobileTitleCarousel.length) {
                $mobileTitleCarousel.slick('setPosition');
            }
        }, 100);

        // Sync carousels and handle animations
        function goToSlide(slideIndex, isManual) {
            if (slideIndex === currentSlide || isAnimating) return;
            
            isAnimating = true;
            
            // Lock scroll position
            lockScroll();

            // Always stop autoplay during transition
            stopAutoPlay();

            // Get current slides
            var $currentContentSlide = $contentCarousel.find('.content-slide').eq(currentSlide);
            var $currentImageSlide = $imageCarousel.find('.image-slide').eq(currentSlide);
            var $currentMobileTitleSlide = $mobileTitleCarousel.length ? $mobileTitleCarousel.find('.mobile-title-slide').eq(currentSlide) : null;
            
            // Update navigation
            $navDots.removeClass('active');
            $navDots.eq(slideIndex).addClass('active');

            // Animate out current slides
            var outPromises = [];
            if ($currentContentSlide.length) {
                outPromises.push(animateContentOut($currentContentSlide));
            }
            if ($currentImageSlide.length) {
                outPromises.push(animateImageOut($currentImageSlide));
            }
            if ($currentMobileTitleSlide && $currentMobileTitleSlide.length) {
                outPromises.push(animateMobileTitleOut($currentMobileTitleSlide));
            }

            // When out animations complete
            Promise.all(outPromises).then(function() {
                // Toggle reverse layout AFTER fade out completes
                var $heroContainer = $section.find('.hero-container');
                if (slideIndex % 2 === 1) {
                    $heroContainer.addClass('reverse-layout');
                } else {
                    $heroContainer.removeClass('reverse-layout');
                }
                
                // Change slides and update button text
                $contentCarousel.slick('slickGoTo', slideIndex);
                $imageCarousel.slick('slickGoTo', slideIndex);
                if ($mobileTitleCarousel.length) {
                    $mobileTitleCarousel.slick('slickGoTo', slideIndex);
                    console.log('Mobile carousel synced to slide:', slideIndex);
                }
                updateCTAButtons(slideIndex); // Update text before animation
                currentSlide = slideIndex;

                // Small delay then animate in new slides
                setTimeout(function() {
                    var $newContentSlide = $contentCarousel.find('.content-slide').eq(slideIndex);
                    var $newImageSlide = $imageCarousel.find('.image-slide').eq(slideIndex);
                    var $newMobileTitleSlide = $mobileTitleCarousel.length ? $mobileTitleCarousel.find('.mobile-title-slide').eq(slideIndex) : null;
                    
                    animateContentIn($newContentSlide);
                    animateImageIn($newImageSlide);
                    if ($newMobileTitleSlide && $newMobileTitleSlide.length) {
                        animateMobileTitleIn($newMobileTitleSlide);
                    }
                    
                    isAnimating = false;
                    
                    // Unlock scroll after a brief delay to ensure animations are done
                    setTimeout(function() {
                        unlockScroll();
                    }, 100);

                    // Always restart autoplay after animation completes
                    setTimeout(function() {
                        if (!isAnimating) { // Double check we're not in another transition
                            restartAutoPlay();
                        }
                    }, 500);
                }, 100);
            });
        }

        // CTA button texts for each slide
        var ctaTexts = {
            primary: [
                'Browse Yourself Online',
                'Start Your Adventure',
                'Shop Now', 
                'Get Started',
                'Explore Options'
            ],
            secondary: [
                'Get Our Expert Help',
                'Learn More',
                'View Gallery',
                'See Examples',
                'Contact Us'
            ]
        };

        // Update CTA button texts (animation handled in main functions)
        function updateCTAButtons(slideIndex) {
            var $ctaButton1 = $('#hero-cta-btn-1');
            var $ctaButton2 = $('#hero-cta-btn-2');
            
            if ($ctaButton1.length && ctaTexts.primary[slideIndex]) {
                $ctaButton1.text(ctaTexts.primary[slideIndex]);
            }
            
            if ($ctaButton2.length && ctaTexts.secondary[slideIndex]) {
                $ctaButton2.text(ctaTexts.secondary[slideIndex]);
            }
        }

        // Navigation dot clicks
        $navDots.on('click', function() {
            var slideIndex = parseInt($(this).data('slide'));
            goToSlide(slideIndex, true); // Pass true to indicate manual change
        });

        // Auto-play functionality
        var autoPlayInterval;
        var autoPlayDelay = 5000; // 5 seconds

        function startAutoPlay() {
            stopAutoPlay(); // Ensure clean state
            autoPlayInterval = setInterval(function() {
                if (!isAnimating) { // Only advance if not currently animating
                    var nextSlide = (currentSlide + 1) % totalSlides;
                    goToSlide(nextSlide, false); // Pass false for automatic change
                }
            }, autoPlayDelay);
        }

        function stopAutoPlay() {
            if (autoPlayInterval) {
                clearInterval(autoPlayInterval);
                autoPlayInterval = null;
            }
        }

        function restartAutoPlay() {
            stopAutoPlay(); // Ensure clean state
            startAutoPlay(); // Start fresh timer
        }

        // Pause on content hover (not image)  
        $section.find('.content-section').on('mouseenter', stopAutoPlay);
        $section.find('.content-section').on('mouseleave', restartAutoPlay);

        // Initialize first slide animations after everything loads
        setTimeout(function() {
            var $firstContentSlide = $contentCarousel.find('.content-slide').eq(0);
            var $firstImageSlide = $imageCarousel.find('.image-slide').eq(0);
            var $firstMobileTitleSlide = $mobileTitleCarousel.length ? $mobileTitleCarousel.find('.mobile-title-slide').eq(0) : null;
            
            // Initialize first slide. isInitial=true keeps opacity untouched so the
            // hero is visible from first paint regardless of when/whether this runs.
            updateCTAButtons(0); // Set initial button text
            animateContentIn($firstContentSlide, true);
            animateImageIn($firstImageSlide, true);
            if ($firstMobileTitleSlide && $firstMobileTitleSlide.length) {
                animateMobileTitleIn($firstMobileTitleSlide, true);
            }
            
            // Start auto-play after initial animation
            setTimeout(startAutoPlay, 2000);
        }, 500);
    }

    // Initialize simple hero when GSAP is ready
    if (typeof gsap !== 'undefined') {
        initSimpleHero();
    } else {
        console.log('GSAP not loaded, simple hero animations disabled');
        // Fallback without animations
        $('.simple-hero-section .content-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            speed: 500
        });
        
        $('.simple-hero-section .image-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            speed: 500,
            asNavFor: '.content-carousel'
        });
    }

    // NEW HERO END

    // IMAGE TRAIL END

    // Only run if GSAP is available
    if (typeof gsap === 'undefined') {
        console.warn('GSAP is required for image trail effects');
        return;
    }

    // body element
    var body = document.body;

    // helper functions
    var MathUtils = {
        // linear interpolation
        lerp: function(a, b, n) { return (1 - n) * a + n * b; },
        // distance between two points
        distance: function(x1,y1,x2,y2) { return Math.hypot(x2-x1, y2-y1); },
        // random float
        getRandomFloat: function(min, max) { return (Math.random() * (max - min) + min); }
    };

    // get the mouse position
    var getMousePos = function(ev) {
        return {
            x: ev.clientX,
            y: ev.clientY
        };
    };

    // mousepos: current mouse position (consistent variable name)
    // lastMousePos: last recorded mouse position (at the time the last image was shown)
    var mousepos = {x: 0, y: 0};
    var lastMousePos = {x: 0, y: 0};
    
    // update the mouse position
    window.addEventListener('mousemove', function(ev) { mousepos = getMousePos(ev); });
    
    // gets the distance from the current mouse position to the last recorded mouse position
    var getMouseDistance = function() { return MathUtils.distance(mousepos.x,mousepos.y,lastMousePos.x,lastMousePos.y); };

    function Image(el) {
        var self = this;
        this.DOM = {el: el};
        // image default styles
        this.defaultStyle = {
            scale: 1,
            x: 0,
            y: 0,
            opacity: 0
        };
        // get sizes/position
        this.getRect();
        // init/bind events
        this.initEvents();
    }
    
    Image.prototype.initEvents = function() {
        var self = this;
        // on resize get updated sizes/position
        window.addEventListener('resize', function() { self.resize(); });
    };
    
    Image.prototype.resize = function() {
        // reset styles
        gsap.set(this.DOM.el, this.defaultStyle);
        // get sizes/position
        this.getRect();
    };
    
    Image.prototype.getRect = function() {
        this.rect = this.DOM.el.getBoundingClientRect();
    };
    
    Image.prototype.isActive = function() {
        // check if image is animating or if it's visible
        return gsap.isTweening(this.DOM.el) || parseFloat(getComputedStyle(this.DOM.el).opacity) > 0;
    };

    function ImageTrail() {
        var self = this;
        // images container
        this.DOM = {content: document.querySelector('.image-trail-section .content')};
        if (!this.DOM.content) {
            console.error('Image trail content container not found');
            return;
        }
        
        // array of Image objs, one per image element
        this.images = [];
        var imageElements = Array.prototype.slice.call(this.DOM.content.querySelectorAll('.content__img'));
        
        imageElements.forEach(function(img) { self.images.push(new Image(img)); });
        
        // total number of images
        this.imagesTotal = this.images.length;
        // upcoming image index
        this.imgPosition = 0;
        // zIndex value to apply to the upcoming image
        this.zIndexVal = 1;
        // mouse distance required to show the next image (increased for more gap between images)
        this.threshold = 150;
        // Track if mouse is inside the section
        this.isMouseInSection = false;
        // Detect touch / non-hover environments
        this.isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
        // Auto-play interval for touch (ms)
        this.autoInterval = 900;
        this.lastAutoTime = performance.now();
        // Animation tuning per input type
        this.animDurations = this.isTouch ? {
            fadeIn: 0.22,
            move: 0.65,
            fadeOut: 1.1
        } : {
            fadeIn: 0.5,
            move: 1.2,
            fadeOut: 2
        };
        this.animSpread = this.isTouch ? 50 : 30;
        this.threshold = this.isTouch ? 100 : this.threshold;
        this.touchBurstRange = {min: 1, max: 1};
        // Touch spiral motion parameters
        this.touchAngle = MathUtils.getRandomFloat(0, Math.PI * 2);
        this.touchRadius = MathUtils.getRandomFloat(0.08, 0.22);
        this.touchAngleStep = MathUtils.getRandomFloat(0.35, 0.6);
        this.touchRadiusStep = MathUtils.getRandomFloat(0.01, 0.025);
        this.touchRadiusMin = 0.05;
        this.touchRadiusMax = 0.35;
        
        if (this.imagesTotal === 0) {
            console.error('No images found for trail effect');
            return;
        }
        
        // Initialize images
        this.images.forEach(function(img, index) {
            gsap.set(img.DOM.el, {
                position: 'absolute',
                top: 0,
                left: 0,
                opacity: 0,
                scale: 1,
                zIndex: 1,
                transformOrigin: 'center center'
            });
        });
        
        // Get the section element
        var section = this.DOM.content.closest('.image-trail-section');
        
        if (this.isTouch) {
            // On touch devices, we auto-run the trail without cursor input.
            this.isMouseInSection = true;
            this.setRandomMousePos();
            lastMousePos = Object.assign({}, mousepos);
        } else {
            // Track mouse enter/leave on the section
            section.addEventListener('mouseenter', function(ev) {
                self.isMouseInSection = true;
                mousepos = getMousePos(ev);
                lastMousePos = mousepos;
            });
            
            section.addEventListener('mouseleave', function() {
                self.isMouseInSection = false;
                lastMousePos = Object.assign({}, mousepos);
            });
            
            // Update mouse position only when inside section
            section.addEventListener('mousemove', function(ev) {
                if (self.isMouseInSection) {
                    mousepos = getMousePos(ev);
                }
            });
        }
        
        // render the images
        requestAnimationFrame(function() { self.render(); });
    }
    
    ImageTrail.prototype.render = function() {
        var self = this;
        // On touch devices, drive the trail automatically
        if (this.isTouch) {
            var now = performance.now();
            if (now - this.lastAutoTime >= this.autoInterval) {
                var selfRef = this;
                // primary point
                this.setRandomMousePos(0);
                this.showNextImage();
                // mirrored point shortly after to mimic dual circular motion
                var mirrorDelay = MathUtils.getRandomFloat(120, 220);
                setTimeout(function() {
                    selfRef.setRandomMousePos(Math.PI);
                    selfRef.showNextImage();
                }, mirrorDelay);
                this.lastAutoTime = now;
            }
            requestAnimationFrame(function() { self.render(); });
            return;
        } else {
            // Only process if mouse is inside the section 
            if (!this.isMouseInSection) {
                requestAnimationFrame(function() { self.render(); });
                return;
            }
            
            // get distance between the current mouse position and the last recorded mouse position
            var distance = getMouseDistance();
            
            // if the distance is greater than the threshold value then show the next image
            if (distance > this.threshold) {
                this.showNextImage();
                
                // update lastMousePos with current mousepos
                lastMousePos = Object.assign({}, mousepos);
            }
        }

        // check when mousemove stops and all images are inactive (not visible and not animating)
        var isIdle = true;
        for (var i = 0; i < this.images.length; i++) {
            var img = this.images[i];
            if (img.isActive()) {
                isIdle = false;
                break;
            }
        }
        // reset z-index initial value
        if (isIdle && this.zIndexVal !== 1) {
            this.zIndexVal = 1;
        }

        // loop..
        requestAnimationFrame(function() { self.render(); });
    };
    
    // Pick a random point within the content area and update the shared mouse position
    ImageTrail.prototype.setRandomMousePos = function(angleOffset) {
        var rect = this.DOM.content.getBoundingClientRect();
        if (this.isTouch) {
            // Spiral-ish progression to mimic circular mouse movement
            this.touchAngle += this.touchAngleStep;
            this.touchRadius += this.touchRadiusStep;
            if (this.touchRadius > this.touchRadiusMax || this.touchRadius < this.touchRadiusMin) {
                this.touchRadiusStep *= -1;
                this.touchRadius = Math.min(Math.max(this.touchRadius, this.touchRadiusMin), this.touchRadiusMax);
            }
            var centerX = rect.left + rect.width / 2;
            var centerY = rect.top + rect.height / 2;
            var offset = angleOffset || 0;
            mousepos = {
                x: centerX + Math.cos(this.touchAngle + offset) * rect.width * this.touchRadius,
                y: centerY + Math.sin(this.touchAngle + offset) * rect.height * this.touchRadius
            };
        } else {
            mousepos = {
                x: rect.left + MathUtils.getRandomFloat(rect.width * 0.1, rect.width * 0.9),
                y: rect.top + MathUtils.getRandomFloat(rect.height * 0.1, rect.height * 0.9)
            };
        }
    };
    
    ImageTrail.prototype.showNextImage = function() {
        var self = this;
        if (this.imgPosition >= this.imagesTotal) {
            this.imgPosition = 0;
            this.zIndexVal = 1;
        }
        
        // show image at position [this.imgPosition]
        var img = this.images[this.imgPosition];
        
        if (!img || !img.DOM.el) {
            console.error('Image not found at position', this.imgPosition);
            return;
        }
        
        // Update rect before using it
        img.getRect();

        // Get image dimensions (fallbacks in case getBoundingClientRect fails)
        var imgWidth = img.rect.width || 300;
        var imgHeight = img.rect.height || 400;
        // Randomize size slightly on touch to vary visuals
        var scaleFactor = this.isTouch ? MathUtils.getRandomFloat(0.6, 1) : 1;

        // Compute mouse coordinates relative to the content container.
        // mousepos is in viewport (client) coordinates, while the images
        // are positioned absolutely inside this.DOM.content. We need to
        // translate to local coordinates so the images align with the
        // cursor correctly.
        var contentRect = this.DOM.content.getBoundingClientRect();
        var localX = mousepos.x - contentRect.left;
        var localY = mousepos.y - contentRect.top;

        // kill any tween on the image
        gsap.killTweensOf(img.DOM.el);

        gsap.timeline()
        // show the image with smooth fade in
        .set(img.DOM.el, {
            opacity: 0,
            scale: 0.7 * scaleFactor,
            zIndex: this.zIndexVal,
            // set x/y relative to the content container
            x: localX - imgWidth/2,
            y: localY - imgHeight/2,
            transformOrigin: 'center center',
            position: 'absolute',
            display: 'block'
        }, 0)
        // smooth fade in and scale up
        .to(img.DOM.el, {
            duration: this.animDurations.fadeIn,
            ease: "power2.out",
            opacity: 1,
            scale: 1 * scaleFactor
        }, 0)
        // animate position with slight movement
        .to(img.DOM.el, {
            duration: this.animDurations.move,
            ease: "power1.out",
            x: localX - imgWidth/2 + MathUtils.getRandomFloat(-this.animSpread, this.animSpread),
            y: localY - imgHeight/2 + MathUtils.getRandomFloat(-this.animSpread, this.animSpread)
        }, 0)
        // then make it disappear smoothly
        .to(img.DOM.el, {
            duration: this.animDurations.fadeOut,
            ease: "power2.inOut",
            opacity: 0,
            scale: 0.95 * scaleFactor
        }, 1);
        
        this.zIndexVal++;
        this.imgPosition++;
    };

    /***********************************/
    /********** Preload stuff **********/

    // Preload images
    var preloadImages = function() {
        return new Promise(function(resolve, reject) {
            // Use imagesLoaded if available, otherwise simple load check
            if (typeof imagesLoaded !== 'undefined') {
                imagesLoaded(document.querySelectorAll('.image-trail-section .content__img'), resolve);
            } else {
                // Simple fallback
                var images = document.querySelectorAll('.image-trail-section .content__img');
                var loadedImages = 0;
                var totalImages = images.length;
                
                if (totalImages === 0) {
                    resolve();
                    return;
                }
                
                Array.prototype.forEach.call(images, function(img) {
                    if (img.complete) {
                        loadedImages++;
                        if (loadedImages === totalImages) resolve();
                    } else {
                        img.addEventListener('load', function() {
                            loadedImages++;
                            if (loadedImages === totalImages) resolve();
                        });
                    }
                });
            }
        });
    };
    
    // Initialize
    preloadImages().then(function() {
        // Remove the loader
        document.body.classList.remove('loading');
        new ImageTrail();
    });
    // IMAGE TRAIL END


    // GRID BLOCKS START
    var blocks = document.querySelectorAll(".team-block");

    // Store current images for each block
    var blockCurrentImages = new Map();

    blocks.forEach(function(block, blockIndex) {
        var imgs = block.querySelectorAll("img");
        if (imgs.length === 0) return;
        
        var current = 0;
        blockCurrentImages.set(block, current);
        
        // Initialize: set first image as active
        imgs.forEach(function(img) {
            img.classList.remove('active', 'fade-out');
        });
        imgs[current].classList.add('active');
        imgs[current].style.opacity = 1;

        // Stagger the animation start for each block
        setTimeout(function() {
            setInterval(function() {
                var nextIndex = (current + 1) % imgs.length;
                var currentImg = imgs[current];
                var nextImg = imgs[nextIndex];
                
                // Start fading in the next image (it will appear over the current one)
                nextImg.classList.add('active');
                nextImg.style.opacity = 1;
                
                // After a short overlap, fade out the current image
                setTimeout(function() {
                    currentImg.classList.remove('active');
                    currentImg.classList.add('fade-out');
                    currentImg.style.opacity = 0;
                    
                    // Clean up classes after transition
                    setTimeout(function() {
                        currentImg.classList.remove('fade-out');
                    }, 1200); // Match CSS transition duration
                    
                }, 100); // Small overlap period
                
                current = nextIndex;
                blockCurrentImages.set(block, current);
            }, 4000); // Change every 4 seconds
        }, blockIndex * 600); // Stagger start times
    });

    // GRID BLOCKS CURSOR START
    var customCursorWeb = $('.custom-cursor-web');
    var rotatingTextDefault = customCursorWeb.find('.rotating-text').first();
    var rotatingTextGrid = customCursorWeb.find('.rotating-text-grid');
    var currentHoveredBlock = null;
    var cursorUpdateInterval = null;

    // Function to update cursor image based on active image in block
    var lastCursorImageSrc = '';
    function updateGridCursorImage(block) {
        var activeImg = $(block).find('img.active');
        if (activeImg.length > 0) {
            var imageSrc = activeImg.attr('src');
            // Only update if image has actually changed
            if (imageSrc !== lastCursorImageSrc) {
                var cursorLogo = customCursorWeb.find('.cursor-logo');
                // Fade out
                cursorLogo.css('opacity', '0');
                
                // Change image and fade back in
                setTimeout(function() {
                    cursorLogo.css('background-image', 'url(' + imageSrc + ')');
                    cursorLogo.css('opacity', '1');
                }, 300); // Half of transition duration
                
                lastCursorImageSrc = imageSrc;
            }
        }
    }

    // Show custom cursor with portfolio image on hover
    $('.team-block').mouseenter(function() {
        var imgs = $(this).find('img');
        if (imgs.length === 0) return;
        
        currentHoveredBlock = this;
        
        // Get the currently visible image (the one with active class)
        updateGridCursorImage(this);
        
        // Start continuous update to track image changes
        cursorUpdateInterval = setInterval(function() {
            if (currentHoveredBlock) {
                updateGridCursorImage(currentHoveredBlock);
            }
        }, 100); // Check every 100ms
        
        customCursorWeb.addClass('slider-active grid-cursor-active');
        $('body').addClass('custom-cursor-active');
        
        // Switch to grid text
        rotatingTextDefault.hide();
        rotatingTextGrid.show();
    });

    $('.team-block').mouseleave(function() {
        currentHoveredBlock = null;
        lastCursorImageSrc = ''; // Reset the last image source
        
        // Stop the update interval
        if (cursorUpdateInterval) {
            clearInterval(cursorUpdateInterval);
            cursorUpdateInterval = null;
        }
        
        customCursorWeb.removeClass('slider-active grid-cursor-active');
        $('body').removeClass('custom-cursor-active');
        
        // Clear the cursor image
        customCursorWeb.find('.cursor-logo').css('background-image', '');
        customCursorWeb.find('.cursor-logo').css('opacity', '1');
        
        // Switch back to default text
        rotatingTextDefault.show();
        rotatingTextGrid.hide();
    });

    // GRID BLOCKS CURSOR END

    // GRID BLOCKS END
    
    // SWIPER CARDS START

    $.fn.matchHeight._maintainScroll = true;
    $(".product_info").iziModal({
        width: 800,
        radius: 30,
        transitionIn: 'bounceInDown',
        overlayColor: 'rgba(20, 140, 168, 0.5)'
    });

    var isDragging = false;
    var startX, startY;

    $('.open-prod-info').on('mousedown touchstart', function(e) {
        isDragging = false;
        var touch = e.type === 'touchstart' ? e.originalEvent.touches[0] : e;
        startX = touch.pageX;
        startY = touch.pageY;
    });

    $('.open-prod-info').on('mousemove touchmove', function(e) {
        var touch = e.type === 'touchmove' ? e.originalEvent.touches[0] : e;
        var moveX = Math.abs(touch.pageX - startX);
        var moveY = Math.abs(touch.pageY - startY);
        if (moveX > 5 || moveY > 5) {
            isDragging = true;
        }
    });

    $('.open-prod-info').click(function(e) {
        e.preventDefault();
        
        // Don't open modal if user was dragging
        if (isDragging) {
            isDragging = false;
            return;
        }
        
        // Get the clicked element (could be card-blog, swiper-slide or single-pick)
        var $element = $(this);
        
        // Reset all fields before populating
        $('.product_info .product-brief').hide().html('');
        $('.product_info .product-name').hide().find('span').html('');
        $('.product_info .product-image').hide().css('background-image', '');
        $('.product_info .product-link').hide().attr('href', '#').text('');
        $('.product_info .product-link2').hide().attr('href', '#').text('');
        $('.product_info .product-linknew').hide().html('');
        $('.product_info .product-linknew2').hide().html('');
        
        if($element.data('product-brief')) {
            $('.product_info .product-brief').html($element.data('product-brief'));
            $('.product_info .product-brief').show();
        }
        if($element.data('product-name')) {
            $('.product_info .product-name > span').html($element.data('product-name'));
            $('.product_info .product-name').css('display', 'inline-block');
        }

        var oldLink1 = $element.data('product-link');
        var oldLink2 = $element.data('product-link2');
        
        if ((oldLink1 === undefined) || (oldLink1 === '')) {
            if($element.data('product-linknew')) {
                $('.product_info .product-linknew').html($element.data('product-linknew'));
                $('.product_info .product-linknew').css('display', 'inline-block');
            }
        }
        if ((oldLink2 === undefined) || (oldLink2 === '')) {
            if($element.data('product-linknew2')) {
                $('.product_info .product-linknew2').html($element.data('product-linknew2'));
                $('.product_info .product-linknew2').css('display', 'inline-block');
            }
        }

        if($element.data('product-image')) {
            $('.product_info .product-image').css('background-image', 'url(' + $element.data('product-image') + ')');
            $('.product_info .product-image').show();
        }
        if($element.data('product-link')) {
            $('.product_info .product-link').attr('href', $element.data('product-link'));
            $('.product_info .product-link').text($element.data('product-linktitle'));
            $('.product_info .product-link').attr('target', $element.data('product-linktarget'));
            $('.product_info .product-link').css('display', 'inline-block');
        }
        if($element.data('product-link2')) {
            $('.product_info .product-link2').attr('href', $element.data('product-link2'));
            $('.product_info .product-link2').text($element.data('product-link2title'));
            $('.product_info .product-link2').attr('target', $element.data('product-link2target'));
            $('.product_info .product-link2').css('display', 'inline-block');
        }
        $('.product_info').iziModal('open');
    })

    // blog-slider
    var $blogSlider = $(".s-blog-slider .slider");
    var slideCount = $blogSlider.find('.slide').length;
    var $sliderWrapper = $(".s-blog-slider .slider-wrapper");
    
    
    var centerPadding = "40px";
    var initialSlide = 0;
    
    if (slideCount === 2) {
        centerPadding = "calc(50% - 152px)";
        initialSlide = 0;
    } else if (slideCount === 3) {
        centerPadding = "calc(50% - 152px)";
        initialSlide = 1;
    } else {
        centerPadding = "calc(50% - 152px)";
        initialSlide = Math.floor(slideCount / 2);
    }
    
    $blogSlider.slick({
        infinite: false,
        dots: false,
        initialSlide: initialSlide,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        centerPadding: centerPadding,
        arrows: true,
        prevArrow: $(".s-blog-slider .slider-prev"),
        nextArrow: $(".s-blog-slider .slider-next"),

        responsive: [
        {
            breakpoint: 1024,
            settings: {
            initialSlide: initialSlide,
            centerMode: true,
            centerPadding: centerPadding,
            },
        },
        ],
    });
    
    // Add data attribute for fewer slides
    $sliderWrapper.attr('data-slide-count', slideCount);
    
    // Hide arrows if less than 5 slides
    // if (slideCount < 5) {
    //     $(".s-blog-slider .slider-controls .slider-arrow").hide();
    // }

    // SWIPER CARDS END

    // SERVICE CARDS START

    (function(){
        var container = document.querySelector('.cards-container');
        if (!container) return;

        var computeHeight = function() {
            // Only compute/set height for desktop layouts where cards are absolute.
            // On small screens cards are positioned statically; clear any inline height.
            if (window.innerWidth < 959) {
                container.style.height = '';
                return;
            }
            var cards = Array.prototype.slice.call(container.querySelectorAll('.service-card'));
            if (!cards.length) return;

            // Use offsetTop/offsetHeight to measure untransformed size relative to
            // the positioned container. This avoids inflated bounding boxes caused
            // by rotations/transforms during hover.
            var maxBottom = 0;
            cards.forEach(function(card) {
                // offsetTop is relative to the nearest positioned ancestor (container)
                var top = card.offsetTop || 0;
                var height = card.offsetHeight || 0;
                var bottom = top + height;
                if (bottom > maxBottom) maxBottom = bottom;
            });

            // Reduce padding to keep height tight but account for shadows/scale.
            var padding = 24;

            var computedMin = parseFloat(getComputedStyle(container).minHeight) || 0;
            var newHeight = Math.max(maxBottom + padding, computedMin);

            // Only set when changed meaningfully to avoid layout thrash
            var currentHeight = parseFloat(container.style.height) || 0;
            if (Math.abs(currentHeight - newHeight) > 1) {
                container.style.height = Math.ceil(newHeight) + 'px';
            }
        };

        // Run on load and resize
        window.addEventListener('load', computeHeight);
        window.addEventListener('resize', function() {
            // throttle using rAF
            window.requestAnimationFrame(computeHeight);
        });

        // Observe changes to card content (e.g., list items added/removed)
        var mo = new MutationObserver(function(mutations) {
            // run after mutations settle
            window.requestAnimationFrame(computeHeight);
        });

        mo.observe(container, { childList: true, subtree: true, characterData: true });

        // Initial compute
        computeHeight();
    })();

    // SERVICE CARDS END

    // LOGO SLIDER START

    // Define the color class sequence
    var colorClasses = [
        "green",
        "yellow",
        "purple",
        "red",
        "blue",
        "burgundy",
        "teal",
        "orange"
    ];

    // Apply sequential colors to all logo-cards
    $(".logo-sliders-vertical .logo-card").each(function(index) {
        var colorClass = colorClasses[index % colorClasses.length];
        $(this).addClass(colorClass);
    });

    // Initialize sliders (no autoplay, CSS animation handles it)
    var commonSettings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        vertical: true,
        autoplay: false,
        pauseOnHover: false,
        speed: 0,
        adaptiveHeight: false,
        variableWidth: false
    };

    $(".slider-up").slick(commonSettings);
    $(".slider-down").slick(commonSettings);

    // Use the existing custom-cursor-web element
    var customCursorWeb = $('.custom-cursor-web');

    // Show custom cursor on hover
    $('.logo-card').mouseenter(function() {
        var logoSrc = $(this).find('img').attr('src');
        customCursorWeb.find('.cursor-logo').css('background-image', 'url(' + logoSrc + ')');
        customCursorWeb.addClass('slider-active');
        $('body').addClass('custom-cursor-active');
        
        // Hide the grid cursor if it exists
        $('.grid-demo-section .cursor').addClass('hidden');
        
        // Pause slider animations
        $('.slider-up .slick-track, .slider-down .slick-track').addClass('paused');
    });

    $('.logo-card').mouseleave(function() {
        customCursorWeb.removeClass('slider-active');
        $('body').removeClass('custom-cursor-active');
        
        // Show the grid cursor again if it exists
        $('.grid-demo-section .cursor').removeClass('hidden');
        
        // Resume slider animations
        $('.slider-up .slick-track, .slider-down .slick-track').removeClass('paused');
    });

    // LOGO SLIDER END

    // Initialize tilt card animations (ES5)
    function initTiltCards() {
        var cards = document.querySelectorAll('[data-tilt]');
        
        for (var i = 0; i < cards.length; i++) {
            (function(card) {
                var y = parseFloat(card.dataset.y) || 0;
                var rot = parseFloat(card.dataset.rot) || 0;
                var baseTransform = 'rotate(' + rot + 'deg)';

                // Set initial transform based on dataset (just rotation, not translateY)
                gsap.set(card, { transform: baseTransform });

                var isAnimating = false;

                // Bell swing effect
                card.addEventListener('mouseenter', function() {
                    if (isAnimating) return;
                    isAnimating = true;

                    // Mark other cards as inactive
                    var allCards = document.querySelectorAll('[data-tilt]');
                    for (var j = 0; j < allCards.length; j++) {
                        if (allCards[j] !== card) {
                            allCards[j].classList.add('inactive');
                        }
                    }

                    gsap.timeline({
                        onComplete: function() { isAnimating = false; }
                    })
                    .to(card, { rotate: rot + 8, duration: 0.15, ease: 'power1.out' })
                    .to(card, { rotate: rot - 6, duration: 0.25, ease: 'power1.inOut' })
                    .to(card, { rotate: rot + 4, duration: 0.25, ease: 'power1.inOut' })
                    .to(card, { rotate: rot, duration: 0.5, ease: 'elastic.out(1, 0.5)' });
                });

                // Dynamic tilt following mouse movement
                card.addEventListener('mousemove', function(e) {
                    var rect = card.getBoundingClientRect();
                    var x = e.clientX - rect.left;
                    var yPos = e.clientY - rect.top;
                    var rotateY = ((x / rect.width) - 0.5) * 20;
                    var rotateX = ((yPos / rect.height) - 0.5) * -20;

                    gsap.to(card, {
                        rotateY: rotateY,
                        rotateX: rotateX,
                        duration: 0.4,
                        ease: 'power2.out'
                    });
                });

                // Reset to base position on leave
                card.addEventListener('mouseleave', function() {
                    // Remove inactive class from all cards on mouse leave
                    var allCards = document.querySelectorAll('[data-tilt]');
                    for (var j = 0; j < allCards.length; j++) {
                        allCards[j].classList.remove('inactive');
                    }

                    gsap.to(card, {
                        rotateX: 0,
                        rotateY: 0,
                        rotation: rot,
                        yPercent: 0,
                        duration: 0.8,
                        ease: 'elastic.out(1, 0.4)'
                    });
                });
            })(cards[i]);
        }
    }

    // Scroll-triggered line drawing animation
    function initScrollAnimations() {
        var drawLine = document.querySelector('.draw-line');
        
        if (drawLine) {
            // Get the path length for animation
            var pathLength = drawLine.getTotalLength();
            
            // Set initial state - line is invisible
            gsap.set(drawLine, {
                strokeDasharray: pathLength,
                strokeDashoffset: pathLength
            });
            
            // Create intersection observer for scroll trigger
            var observer = new IntersectionObserver(function(entries) {
                for (var i = 0; i < entries.length; i++) {
                    var entry = entries[i];
                    if (entry.isIntersecting) {
                        // Animate the line drawing
                        gsap.to(drawLine, {
                            strokeDashoffset: 0,
                            duration: 2,
                            ease: 'power2.out',
                            delay: 0.2
                        });
                        
                        // Stop observing after animation starts
                        observer.unobserve(entry.target);
                    }
                }
            }, {
                threshold: 0.3,
                rootMargin: '0px 0px -100px 0px'
            });
            
            // Start observing the line container
            var lineContainer = document.querySelector('.future__line');
            if (lineContainer) {
                observer.observe(lineContainer);
            }
        }
    }

    // Initialize animations when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initTiltCards();
            initScrollAnimations();
        });
    } else {
        initTiltCards();
        initScrollAnimations();
    }

});
